import { z } from 'zod';
export const ventCapTypeSchema = z.enum(['PASSIVE', 'ACTIVE']);

export type VentCap = z.infer<typeof ventCapSchema>;
export const ventCapSchema = z.object({
  id: z.number(),
  projectId: z.number(),
  installationId: z.number(),
  planCoordinateX: z.number().nullable().optional(),
  planCoordinateY: z.number().nullable().optional(),
  label: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  sizeMm: z.number(),
  type: ventCapTypeSchema,
  installedAt: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});
